import { render } from "./FullWaveFormVisualizer.vue?vue&type=template&id=8a29d462&scoped=true"
import script from "./FullWaveFormVisualizer.vue?vue&type=script&lang=js"
export * from "./FullWaveFormVisualizer.vue?vue&type=script&lang=js"

import "./FullWaveFormVisualizer.vue?vue&type=style&index=0&id=8a29d462&scoped=true&lang=scss"

import exportComponent from "/Users/ramazansapar/qbox-transcriber-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8a29d462"]])

export default __exports__